export default __webpack_public_path__ + "static/media/secret_invasion_001.8ecae0f8.jpg";